import { Modal } from "antd";
import { history } from "umi";
import { getAxiosInstance, useApp, useLoginInfo, useTiMaxStore } from "@ti/max";
import { baseUrl } from "../../../config/common";

/**
 * Error Code 处理
 */
const errorHandler = (response) => {
  const { url } = response.config;
  const { code, text } = response.data;

  // 白名单
  if (["/system/getMicroWebToken"].includes(url)) {
    return;
  }

  let msg;

  // 接口异常处理
  if (!code) {
    msg = "响应格式错误，没有code";
  }

  // 业务异常处理
  if (!["200", "S00000"].includes(code)) {
    if (code === "402") {
      // 登录失效
      msg = "please login";
      setTimeout(() => {
        Modal.destroyAll();
        history.replace("/login");
      }, 1500);
    } else if (text) {
      // 业务报错
      msg = text;
    }
  }
  return msg;
};

/**
 * 请求前处理
 */
const beforeRequest = (config) => {
  // 设置 token
  const { token } = useLoginInfo.getState() || {};
  if (!config.headers.get("Authorization")) {
    config.headers.set("Authorization", token);
  }
  const publicIP = localStorage.getItem("publicIP");
  if (publicIP) {
    config.headers.set("X-Public-IP", publicIP);
  }

  // 设置 locale
  const { locale } = useTiMaxStore.getState();
  config.headers.set("Locale", locale.split("-")[0]);
};

/**
 * 请求后处理
 */
const beforeResponse = (response) => {
  const { message } = useApp.getState();

  // 错误处理
  const msg = errorHandler(response);
  if (msg) {
    message.error(msg);
    if (response.config.rejectOnError) {
      return Promise.reject(`[request]: ${msg}`);
    }
  }
  // 数据处理
  if (response.data.pageLimit) {
    response.data.total = response.data.pageLimit.totalCount;
    response.data.page = response.data.pageLimit.currentPageNo;
    response.data.pageSize = response.data.pageLimit.pageLength;
  }

  return response.data;
};

/**
 * axios 实例
 */
const request = getAxiosInstance(
  {
    baseURL: baseUrl,
    timeout: 5 * 60 * 1000,
  },
  {
    beforeRequest,
    beforeResponse,
  },
);

export default request;
